import React, { useState } from "react";
import classNames from "classnames";
import { m } from "framer-motion";

const InViewWrapper = ({
  children,
  unobserveAfterEntry,
  observerOptions: _observerOptions,
  className,
  inViewClassName,
  style,
  inViewStyle,
  onEnter,
  onExit,
  threshold,
  rootMargin,
}) => {
  const [visible, setVisible] = useState();

  const handleEntry = () => {
    if (onEnter) {
      onEnter();
    }
    setVisible(true);
  };

  const handleExit = () => {
    if (onExit) {
      onExit();
    }
    setVisible(false);
  };

  return (
    <m.div
      className={classNames(className, {
        [inViewClassName]: visible,
      })}
      style={visible ? inViewStyle : style}
      viewport={{
        once: unobserveAfterEntry,
        margin: rootMargin,
        amount: threshold,
      }}
      onViewportEnter={handleEntry}
      onViewportLeave={handleExit}
    >
      {children}
    </m.div>
  );
};

InViewWrapper.defaultProps = {
  threshold: "some",
  rootMargin: "0px",
  inViewClassName: "",
};

export default InViewWrapper;
